import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'
import { history } from 'src/core/router'

export default class {
  @observable data = {
    uid: 0,
    dailyList: [],
    monthList: [],
    dailyTotal: 0,
    monthlyTotal: 0,
    canRequest: true,
    lang: {},
  }

  @action async rechargeRewardList(map, lang) {
    this.data.lang = lang
    let d = await http.post('/web/rechargeReward/list', map)
    if (d && d.code == 0 && d.res && d.res.list) {
      let dailyList = []
      let monthList = []
      for (let i = 0; i < d.res.list.length; i++) {
        if (d.res.list[i].rechargeType == "daily") {
          dailyList.push(d.res.list[i])
        }
        if (d.res.list[i].rechargeType == "monthly") {

          // for (let ii = 0; ii < d.res.list[i].rewardDetail.length; ii++) {
          //   d.res.list[i].rewardDetail[ii].rewardName = d.res.list[i].rewardDetail[ii].rewardName.replace('vip 1 (30days', 'vip 1 (30days')
          //   d.res.list[i].rewardDetail[ii].rewardName = d.res.list[i].rewardDetail[ii].rewardName.replace('vip 2 (30days', 'vip 2 (30days')
          //   d.res.list[i].rewardDetail[ii].rewardName = d.res.list[i].rewardDetail[ii].rewardName.replace('vip 3 (30days', 'vip 3 (30days')
          //   d.res.list[i].rewardDetail[ii].rewardName = d.res.list[i].rewardDetail[ii].rewardName.replace('vip 4 (30days', 'vip 4 (30days')
          //   d.res.list[i].rewardDetail[ii].rewardName = d.res.list[i].rewardDetail[ii].rewardName.replace('vip 5 (30days', 'vip 5 (30days')
          // }

          // if (d.res.list[i].id == 12) {
          //   d.res.list[i].rewardDetail.push({
          //     "id": 0,
          //     "rechargeLevelId": 0,
          //     "rechargeType": "monthly",
          //     "rewardType": "",
          //     "rewardId": 0,
          //     "rewardNum": 0,
          //     "sort": 0,
          //     "pic": "https://img.chatie.live/app/source/duid_icon.png",
          //     "rewardName": "AABBAA"
          //   })
          //   d.res.list[i].rewardDetail.push({
          //     "id": 0,
          //     "rechargeLevelId": 0,
          //     "rechargeType": "monthly",
          //     "rewardType": "",
          //     "rewardId": 0,
          //     "rewardNum": 0,
          //     "sort": 0,
          //     "pic": "/img/activity/recharge/gift.png",
          //     "rewardName": "Custom Gift for 30 Days"
          //   })
          // }

          // if (d.res.list[i].id==11) {
          //   d.res.list[i].rewardDetail.push({
          //     "id": 0,
          //     "rechargeLevelId": 0,
          //     "rechargeType": "monthly",
          //     "rewardType": "",
          //     "rewardId": 0,
          //     "rewardNum": 0,
          //     "sort": 0,
          //     "pic": "/img/activity/recharge/Profile_Flash_Money.png",
          //     "rewardName": "Profile Flash Money x 30 days"
          //   })
          // }

          if (d.res.list[i].id == 11) {
            for (let ii = 0; ii < d.res.list[i].rewardDetail.length; ii++) {
              if (d.res.list[i].rewardDetail[ii].rewardType == "sp") {
                d.res.list[i].rewardDetail[ii].pic = "/img/activity/recharge/img_152.png"
                d.res.list[i].rewardDetail[ii].rewardName = "Profile Flash Money x 30 days"
              }
            }
            // d.res.list[i].rewardDetail.push({
            //   "id": 0,
            //   "rechargeLevelId": 0,
            //   "rechargeType": "monthly",
            //   "rewardType": "",
            //   "rewardId": 0,
            //   "rewardNum": 0,
            //   "sort": 0,
            //   "pic": "/img/activity/recharge/Profile_Flash_Money.png",
            //   "rewardName": "Profile Flash Money x 30 days"
            // })
          }

          if (d.res.list[i].id == 12) {
            for (let ii = 0; ii < d.res.list[i].rewardDetail.length; ii++) {
              if (d.res.list[i].rewardDetail[ii].rewardType == "sp") {
                d.res.list[i].rewardDetail[ii].pic = "/img/activity/recharge/img_152.png"
                d.res.list[i].rewardDetail[ii].rewardName = "Profile Flash Money x 30 days"
              }
            }
            // d.res.list[i].rewardDetail.push({
            //   "id": 0,
            //   "rechargeLevelId": 0,
            //   "rechargeType": "monthly",
            //   "rewardType": "",
            //   "rewardId": 0,
            //   "rewardNum": 0,
            //   "sort": 0,
            //   "pic": "/img/activity/recharge/Profile_Flash_Money.png",
            //   "rewardName": "Profile Flash Money x 30 days"
            // })
          }

          // if (d.res.list[i].id==10) {    
          //   d.res.list[i].rewardDetail.push({
          //     "id": 0,
          //     "rechargeLevelId": 0,
          //     "rechargeType": "monthly",
          //     "rewardType": "",
          //     "rewardId": 0,
          //     "rewardNum": 0,
          //     "sort": 0,
          //     "pic": "https://img.chatie.live/app/medal/images/recharge_benefit_medal3.png",
          //     "rewardName": "Medal"
          //   })            
          // }

          // if (d.res.list[i].id==11 ) {    
          //   d.res.list[i].rewardDetail.push({
          //     "id": 0,
          //     "rechargeLevelId": 0,
          //     "rechargeType": "monthly",
          //     "rewardType": "",
          //     "rewardId": 0,
          //     "rewardNum": 0,
          //     "sort": 0,
          //     "pic": "https://img.chatie.live/app/medal/images/recharge_benefit_medal2.png",
          //     "rewardName": "Medal"
          //   })            
          // }

          // if (d.res.list[i].id==12) {    
          //   d.res.list[i].rewardDetail.push({
          //     "id": 0,
          //     "rechargeLevelId": 0,
          //     "rechargeType": "monthly",
          //     "rewardType": "",
          //     "rewardId": 0,
          //     "rewardNum": 0,
          //     "sort": 0,
          //     "pic": "https://img.chatie.live/app/medal/images/recharge_benefit_medal1.png",
          //     "rewardName": "Medal"
          //   })            
          // }
          monthList.push(d.res.list[i])
        }
      }
      this.data.dailyTotal = d.res.dailyTotal || 0
      this.data.monthlyTotal = d.res.monthlyTotal || 0
      this.data.dailyList = dailyList
      this.data.monthList = monthList
    }
    return d.res
  }

  @action async getCharge(id) {
    if (this.data.canRequest == false) {
      return
    }
    this.data.canRequest = false
    let d = await http.post('/web/rechargeReward/getReward', { rechargeLevelId: id })
    this.data.canRequest = true
    this.rechargeRewardList()
    if (d.code == 0) {
      return true
    } else {
      return false
    }
  }
}



// WEBPACK FOOTER //
// src/store/activity/recharge.js